import React, { useContext, useMemo } from 'react';
import { TranslatorContext } from '../../context/Translator';
import { IconFieldComponent } from '../fields';
import { PaymentChartComponent, RevenueChartComponent } from '../charts';

export default function RevenueCardComponent({ CurrentData = {} }) {
  const { t, n } = useContext(TranslatorContext);

  const { totalIn, totalOut, netIncome } = useMemo(() => {
    // Calculate total amounts
    const cashInOutStats = Array.isArray(CurrentData.cashInOutStats) ? CurrentData.cashInOutStats : [];
    const totalIn = cashInOutStats.reduce((sum, item) => sum + (item.totalAmountCashIn || 0), 0);
    const totalOut = cashInOutStats.reduce((sum, item) => sum + (item.totalAmountCashOut || 0), 0);
   
    const netIncome =
      totalOut > totalIn ? totalOut - totalIn : totalIn - totalOut;

    // Calculate daily totals for chart
    // const last7Days = [...Array(7)]
    //   .map((_, i) => {
    //     const date = new Date();
    //     date.setDate(date.getDate() - i);
    //     return date.toISOString().split('T')[0];
    //   })
    //   .reverse();

    // const dailyData = last7Days.map(date => {
    //     const currentDayTotal = CurrentData.cashInData?.reduce((sum, item) => sum + (item.total || 0), 0) || 0;
    //     return {
    //         date,
    //         displayDate: new Date(date).toLocaleDateString('en-US', {
    //             weekday: 'short'
    //         }).toLowerCase(),
    //         current: currentDayTotal
    //     };
    // });

    return {
      totalIn,
      totalOut,
      netIncome,
    };
  }, [CurrentData.cashInOutStats]);

  return (
    <div className='mc-card'>
      <div className='mc-revenue-card-header'>
        <h5 className='mc-card-title'>{t('revenue_report')}</h5>
      </div>
      <div className='mc-revenue-card-group'>
        <div className='mc-revenue-card-report'>
          <i className='material-icons green'>cases</i>
          <h3>
            <span>{t('Nạp')}</span>
            {n(totalIn)}
          </h3>
        </div>
        <div className='mc-revenue-card-report'>
        <i className='material-icons' style={{ color: 'red' }}>bookmarks</i>

          <h3>
            <span>{t('Rút')}</span>
            {n(totalOut)}
          </h3>
        </div>
        <div className='mc-revenue-card-report'>
          <i className='material-icons purple'>layers</i>
          <h3>
            <span>{t(totalOut > totalIn ? 'Lỗ' : 'Lãi')}</span>
            {n(netIncome)}
          </h3>
        </div>
      </div>
      <PaymentChartComponent data={CurrentData.cashInOutStats} />
    </div>
  );
}
